import React from "react";
import ToggleTextareaComponent from "@common/components/shared/forms/ToggleTextareaComponent";
import { useFormContext } from "react-hook-form";

const DiscussionForm = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const [discussedSelfExclusion] = watch(["discussedSelfExclusion"]);
  return (
    <>
      <p>
        <b>Confirm you have discussed the following:</b>
      </p>
      <div className="m-1">
        <ToggleTextareaComponent
          control={control}
          register={register}
          watch={watch}
          toggleName="providedLeaflet"
          toggleLabel="Provided a safer gambling leaflet"
          toggleError={errors.providedLeaflet}
          textareaName="reasonNotProvidedLeaflet"
          textareaPlaceholder="Please enter reason why not"
          textareaError={errors.reasonNotProvidedLeaflet}
        />
        <ToggleTextareaComponent
          control={control}
          register={register}
          watch={watch}
          toggleName="seekHelp"
          toggleLabel="Explained how to seek help if they are worried about gambling"
          toggleError={errors.seekHelp}
          textareaName="reasonNotSeekHelp"
          textareaPlaceholder="Please enter reason why not"
          textareaError={errors.reasonNotSeekHelp}
        />

        <ToggleTextareaComponent
          control={control}
          register={register}
          watch={watch}
          toggleName="discussedSelfExclusion"
          toggleLabel="Explained self-exclusion process"
          toggleError={errors.discussedSelfExclusion}
          textareaName="reasonNotDiscussedSelfExclusion"
          textareaPlaceholder="Please enter reason why not"
          textareaError={errors.reasonNotDiscussedSelfExclusion}
        />

        {discussedSelfExclusion && (
          <ToggleTextareaComponent
            control={control}
            register={register}
            watch={watch}
            toggleName="selfExclude"
            toggleLabel="Does customer wish to self-exclude"
            toggleError={errors.selfExclude}
            textareaName="reasonNotSelfExclude"
            textareaPlaceholder="Please enter reason why not"
            textareaError={errors.reasonNotSelfExclude}
          />
        )}
      </div>
    </>
  );
};

export default DiscussionForm;
